import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
const HEADER_BLOCK = Object.freeze({
  ONE: "header-one",
  TWO: "header-two",
  THREE: "header-three",
  FOUR: "header-four",
  FIVE: "header-five",
  SIX: "header-six",
  PARAGRAPH: "unstyled"
});
const WRAP = "wrap";
const NO_WRAP = "nowrap";
const UNSTYLED = "unstyled";
const BLOCKQUOTE = "blockquote";
const NUMBERED_LIST_TYPE = "ordered-list-item";
const BULLET_LIST_TYPE = "unordered-list-item";
const LINK_BUTTON_TYPE = "wix-draft-plugin-link-button";
const ACTION_BUTTON_TYPE = "wix-draft-plugin-action-button";
const CODE_BLOCK_TYPE = "code-block";
const DIVIDER_TYPE = "wix-draft-plugin-divider";
const EMOJI_TYPE = "wix-draft-plugin-emoji";
const FILE_UPLOAD_TYPE = "wix-draft-plugin-file-upload";
const GALLERY_TYPE = "wix-draft-plugin-gallery";
const GIPHY_TYPE = "wix-draft-plugin-giphy";
const HASHTAG_TYPE = "wix-draft-plugin-hashtag";
const HEADERS_MARKDOWN_TYPE = "wix-draft-plugin-headers-markdown";
const HTML_TYPE = "wix-draft-plugin-html";
const IMAGE_TYPE = "wix-draft-plugin-image";
const IMAGE_TYPE_LEGACY = "IMAGE";
const INDENT_TYPE = "wix-rich-content-plugin-indent";
const LINE_SPACING_TYPE = "line-spacing";
const HEADINGS_DROPDOWN_TYPE = "wix-rich-content-plugin-headings";
const SPOILER_TYPE = "wix-rich-content-plugin-spoiler";
const COLLAPSIBLE_LIST_TYPE = "wix-rich-content-plugin-collapsible-list";
const EXTERNAL_LINK_TYPE = "wix-draft-plugin-external-link";
const LINK_TYPE = "LINK";
const LINK_PREVIEW_TYPE = "wix-draft-plugin-link-preview";
const EXTERNAL_MENTIONS_TYPE = "wix-draft-plugin-external-mentions";
const MENTION_TYPE = "mention";
const SOUND_CLOUD_TYPE = "wix-draft-plugin-sound-cloud";
const TEXT_COLOR_TYPE = "wix-rich-content-text-color";
const TEXT_HIGHLIGHT_TYPE = "wix-rich-content-text-highlight";
const UNDO_REDO_TYPE = "wix-rich-content-undo-redo";
const APP_EMBED_TYPE = "wix-draft-plugin-vertical-embed";
const VERTICAL_EMBED_TYPE = "wix-draft-plugin-vertical-embed";
const VIDEO_TYPE = "wix-draft-plugin-video";
const AUDIO_TYPE = "ricos-audio";
const VIDEO_TYPE_LEGACY = "VIDEO-EMBED";
const POLL_TYPE = "wix-draft-plugin-poll";
const TABLE_TYPE = "wix-rich-content-plugin-table";
const ANCHOR_TYPE = "ANCHOR";
const PREVIEW = "PREVIEW";
const EMBED_TYPE = "EMBED";
const EXTERNAL = "EXTERNAL";
const RICOS_COLLAPSIBLE_LIST_TYPE = "ricos-collapsible-list";
const RICOS_ACTION_BUTTON_TYPE = "ricos-action-button";
const RICOS_DIVIDER_TYPE = "ricos-divider";
const RICOS_FILE_TYPE = "ricos-file";
const RICOS_GALLERY_TYPE = "ricos-gallery";
const RICOS_GIPHY_TYPE = "ricos-giphy";
const RICOS_HTML_TYPE = "ricos-html";
const RICOS_IMAGE_TYPE = "ricos-image";
const RICOS_CAPTION_TYPE = "ricos-caption";
const RICOS_INDENT_TYPE = "ricos-indent";
const RICOS_LINE_SPACING_TYPE = "ricos-line-spacing";
const RICOS_LINK_BUTTON_TYPE = "ricos-link-button";
const RICOS_LINK_PREVIEW_TYPE = "ricos-link-preview";
const RICOS_POLL_TYPE = "ricos-poll";
const RICOS_TABLE_TYPE = "ricos-table";
const RICOS_TEXT_COLOR_TYPE = "ricos-text-color";
const RICOS_TEXT_HIGHLIGHT_TYPE = "ricos-text-highlight";
const RICOS_VERTICAL_EMBED_TYPE = "ricos-vertical-embed";
const RICOS_VIDEO_TYPE = "ricos-video";
const RICOS_ANCHOR_TYPE = "ricos-anchor";
const RICOS_LINK_TYPE = "ricos-link";
const RICOS_MENTION_TYPE = "ricos-mention";
const RICOS_FONT_SIZE_TYPE = "ricos-font-size";
const RICOS_LAYOUT_TYPE = "ricos-layout";
const TIPTAP_DIVIDER_TYPE = Node_Type.DIVIDER;
const TIPTAP_FIGURE_TYPE = "FIGURE";
const TIPTAP_IMAGE_TYPE = Node_Type.IMAGE;
const TIPTAP_CAPTION_TYPE = Node_Type.CAPTION;
const TIPTAP_GALLERY_TYPE = Node_Type.GALLERY;
const TIPTAP_FILE_TYPE = Node_Type.FILE;
const TIPTAP_GIF_TYPE = Node_Type.GIF;
const TIPTAP_VIDEO_TYPE = Node_Type.VIDEO;
const TIPTAP_AUDIO_TYPE = Node_Type.AUDIO;
const TIPTAP_LINK_PREVIEW_TYPE = Node_Type.LINK_PREVIEW;
const TIPTAP_EMBED_TYPE = Node_Type.EMBED;
const TIPTAP_POLL_TYPE = Node_Type.POLL;
const TIPTAP_APP_EMBED_TYPE = Node_Type.APP_EMBED;
const TIPTAP_COLLAPSIBLE_LIST_TYPE = Node_Type.COLLAPSIBLE_LIST;
const TIPTAP_COLLAPSIBLE_ITEM_TYPE = Node_Type.COLLAPSIBLE_ITEM;
const TIPTAP_COLLAPSIBLE_ITEM_TITLE_TYPE = Node_Type.COLLAPSIBLE_ITEM_TITLE;
const TIPTAP_COLLAPSIBLE_ITEM_BODY_TYPE = Node_Type.COLLAPSIBLE_ITEM_BODY;
const TIPTAP_HTML_TYPE = Node_Type.HTML;
const TIPTAP_LINK_BUTTON_TYPE = "LINK_BUTTON";
const TIPTAP_ACTION_BUTTON_TYPE = "ACTION_BUTTON";
const TIPTAP_CODE_BLOCK_TYPE = Node_Type.CODE_BLOCK;
const TIPTAP_TABLE_TYPE = Node_Type.TABLE;
const TIPTAP_TABLE_ROW_TYPE = Node_Type.TABLE_ROW;
const TIPTAP_TABLE_CELL_TYPE = Node_Type.TABLE_CELL;
const TIPTAP_TABLE_HEADER_CELL_TYPE = "TABLE_HEADER_CELL";
const TIPTAP_LAYOUT_TYPE = Node_Type.LAYOUT;
const TIPTAP_LAYOUT_CELL_TYPE = Node_Type.LAYOUT_CELL;
const RICOS_NODE_TYPE_TO_DATA_FIELD = {
  [Node_Type.BUTTON]: "buttonData",
  [Node_Type.DIVIDER]: "dividerData",
  [Node_Type.FILE]: "fileData",
  [Node_Type.GALLERY]: "galleryData",
  [Node_Type.GIF]: "gifData",
  [Node_Type.HTML]: "htmlData",
  [Node_Type.IMAGE]: "imageData",
  [Node_Type.CAPTION]: "captionData",
  [Node_Type.COLLAPSIBLE_LIST]: "collapsibleListData",
  [Node_Type.LINK_PREVIEW]: "linkPreviewData",
  [Node_Type.APP_EMBED]: "appEmbedData",
  [Node_Type.VIDEO]: "videoData",
  [Node_Type.POLL]: "pollData",
  [Node_Type.TABLE]: "tableData",
  [Node_Type.TABLE_CELL]: "tableCellData",
  [Node_Type.PARAGRAPH]: "paragraphData",
  [Node_Type.LIST_ITEM]: "paragraphData",
  [Node_Type.HEADING]: "headingData",
  [Node_Type.CODE_BLOCK]: "codeBlockData",
  [Node_Type.BLOCKQUOTE]: "paragraphData",
  [Node_Type.EMBED]: "embedData",
  [Node_Type.EXTERNAL]: "externalData",
  [Node_Type.AUDIO]: "audioData",
  [Node_Type.CAPTION]: "captionData",
  [Node_Type.TEXT]: "textData",
  [Node_Type.BULLETED_LIST]: "bulletedListData",
  [Node_Type.ORDERED_LIST]: "orderedListData",
  [Node_Type.COLLAPSIBLE_ITEM]: void 0,
  [Node_Type.COLLAPSIBLE_ITEM_TITLE]: void 0,
  [Node_Type.COLLAPSIBLE_ITEM_BODY]: void 0,
  [Node_Type.TABLE_ROW]: void 0,
  [Node_Type.UNRECOGNIZED]: void 0,
  [Node_Type.MAP]: void 0,
  [Node_Type.LAYOUT]: void 0,
  [Node_Type.LAYOUT_CELL]: "layoutCellData"
};
export {
  ACTION_BUTTON_TYPE,
  ANCHOR_TYPE,
  APP_EMBED_TYPE,
  AUDIO_TYPE,
  BLOCKQUOTE,
  BULLET_LIST_TYPE,
  CODE_BLOCK_TYPE,
  COLLAPSIBLE_LIST_TYPE,
  DIVIDER_TYPE,
  EMBED_TYPE,
  EMOJI_TYPE,
  EXTERNAL,
  EXTERNAL_LINK_TYPE,
  EXTERNAL_MENTIONS_TYPE,
  FILE_UPLOAD_TYPE,
  GALLERY_TYPE,
  GIPHY_TYPE,
  HASHTAG_TYPE,
  HEADERS_MARKDOWN_TYPE,
  HEADER_BLOCK,
  HEADINGS_DROPDOWN_TYPE,
  HTML_TYPE,
  IMAGE_TYPE,
  IMAGE_TYPE_LEGACY,
  INDENT_TYPE,
  LINE_SPACING_TYPE,
  LINK_BUTTON_TYPE,
  LINK_PREVIEW_TYPE,
  LINK_TYPE,
  MENTION_TYPE,
  NO_WRAP,
  NUMBERED_LIST_TYPE,
  POLL_TYPE,
  PREVIEW,
  RICOS_ACTION_BUTTON_TYPE,
  RICOS_ANCHOR_TYPE,
  RICOS_CAPTION_TYPE,
  RICOS_COLLAPSIBLE_LIST_TYPE,
  RICOS_DIVIDER_TYPE,
  RICOS_FILE_TYPE,
  RICOS_FONT_SIZE_TYPE,
  RICOS_GALLERY_TYPE,
  RICOS_GIPHY_TYPE,
  RICOS_HTML_TYPE,
  RICOS_IMAGE_TYPE,
  RICOS_INDENT_TYPE,
  RICOS_LAYOUT_TYPE,
  RICOS_LINE_SPACING_TYPE,
  RICOS_LINK_BUTTON_TYPE,
  RICOS_LINK_PREVIEW_TYPE,
  RICOS_LINK_TYPE,
  RICOS_MENTION_TYPE,
  RICOS_NODE_TYPE_TO_DATA_FIELD,
  RICOS_POLL_TYPE,
  RICOS_TABLE_TYPE,
  RICOS_TEXT_COLOR_TYPE,
  RICOS_TEXT_HIGHLIGHT_TYPE,
  RICOS_VERTICAL_EMBED_TYPE,
  RICOS_VIDEO_TYPE,
  SOUND_CLOUD_TYPE,
  SPOILER_TYPE,
  TABLE_TYPE,
  TEXT_COLOR_TYPE,
  TEXT_HIGHLIGHT_TYPE,
  TIPTAP_ACTION_BUTTON_TYPE,
  TIPTAP_APP_EMBED_TYPE,
  TIPTAP_AUDIO_TYPE,
  TIPTAP_CAPTION_TYPE,
  TIPTAP_CODE_BLOCK_TYPE,
  TIPTAP_COLLAPSIBLE_ITEM_BODY_TYPE,
  TIPTAP_COLLAPSIBLE_ITEM_TITLE_TYPE,
  TIPTAP_COLLAPSIBLE_ITEM_TYPE,
  TIPTAP_COLLAPSIBLE_LIST_TYPE,
  TIPTAP_DIVIDER_TYPE,
  TIPTAP_EMBED_TYPE,
  TIPTAP_FIGURE_TYPE,
  TIPTAP_FILE_TYPE,
  TIPTAP_GALLERY_TYPE,
  TIPTAP_GIF_TYPE,
  TIPTAP_HTML_TYPE,
  TIPTAP_IMAGE_TYPE,
  TIPTAP_LAYOUT_CELL_TYPE,
  TIPTAP_LAYOUT_TYPE,
  TIPTAP_LINK_BUTTON_TYPE,
  TIPTAP_LINK_PREVIEW_TYPE,
  TIPTAP_POLL_TYPE,
  TIPTAP_TABLE_CELL_TYPE,
  TIPTAP_TABLE_HEADER_CELL_TYPE,
  TIPTAP_TABLE_ROW_TYPE,
  TIPTAP_TABLE_TYPE,
  TIPTAP_VIDEO_TYPE,
  UNDO_REDO_TYPE,
  UNSTYLED,
  VERTICAL_EMBED_TYPE,
  VIDEO_TYPE,
  VIDEO_TYPE_LEGACY,
  WRAP
};
//# sourceMappingURL=consts.js.map
